module.exports = __webpack_public_path__ + "img/xxhl3.dfd0a11e.png";